<template>
    <b-col>
    <recognition-update-form></recognition-update-form>
    </b-col>
</template>

<script>
 import RecognitionUpdateForm from '@/components/applicant/recognation/RecognitionUpdateForm'
    export default {
        name: "Index",
        components:{
          RecognitionUpdateForm
        },
        computed:{

        },
       methods:{
         fetchRecognition(){
            this.$store.dispatch('applicant/actionSetRecognition', this.$route.params.id)
          }
        },
    }
</script>

<style scoped>

</style>
